(function () {
  function setup(root) {
    if (root.dataset.wctReady) return;
    root.dataset.wctReady = '1';
    var form = root.querySelector('form');
    var ok = root.querySelector('.wct__msg--ok');
    var KEY = 'wct_' + (root.dataset.sid || 'x');
    var sheet = root.dataset.sheet;

    if (form) {
      form.addEventListener('submit', function () {
        var f = form.elements;
        var data = {
          n: f['contact[name]'] ? f['contact[name]'].value.trim() : '',
          e: f['contact[email]'] ? f['contact[email]'].value.trim() : '',
          p: f['contact[phone]'] ? f['contact[phone]'].value.trim() : '',
          b: f['contact[body]'] ? f['contact[body]'].value.trim() : ''
        };
        try { sessionStorage.setItem(KEY, JSON.stringify(data)); } catch (err) {}
        if (sheet && data.n && data.e.indexOf('@') > 0 && data.b) {
          var body = new URLSearchParams({ name: data.n, email: data.e, phone: data.p, message: data.b, page: window.location.href });
          try { fetch(sheet, { method: 'POST', mode: 'no-cors', body: body, keepalive: true }); } catch (err) {}
        }
        var btn = form.querySelector('.wct__submit');
        if (btn) { btn.disabled = true; btn.textContent = root.dataset.sending || 'Sending...'; }
      });
    }

    if (!ok) return;
    ok.scrollIntoView({ block: 'center' });
    var action = root.dataset.action;
    var delay = (parseInt(root.dataset.delay, 10) || 0) * 1000;
    var saved = null;
    try { saved = JSON.parse(sessionStorage.getItem(KEY) || 'null'); sessionStorage.removeItem(KEY); } catch (err) {}

    if (action === 'redirect' && root.dataset.url) {
      setTimeout(function () { window.location.href = root.dataset.url; }, delay);
    } else if (action === 'whatsapp' && root.dataset.wa) {
      var text = root.dataset.waText || '';
      if (saved) {
        text += '\n\nName: ' + saved.n + '\nEmail: ' + saved.e + (saved.p ? '\nPhone: ' + saved.p : '') + '\nMessage: ' + saved.b;
      }
      setTimeout(function () {
        window.location.href = 'https://wa.me/' + root.dataset.wa + '?text=' + encodeURIComponent(text);
      }, delay);
    }
  }

  function init() {
    document.querySelectorAll('[data-wct]').forEach(setup);
  }
  init();
  document.addEventListener('shopify:section:load', init);
})();